/**
 * Business details shown in the terms and privacy statement. Fill these in
 * once; both pages read them from here.
 */
export const LEGAL = {
  /** Legal name of the business (or your own name for a sole proprietorship). */
  company: 'Even Aandacht',
  kvk: '99676060',
  /** Optional for now; shown on both pages once filled in ("Straat 1, 1234 AB Plaats"). */
  address: 'E. Pankhurststraat 51, 1103 MT Amsterdam',
  email: 'info@evenaandacht.nl',
  /** Date these versions take effect. */
  effectiveDate: '17 oktober 2026',
  platformFee: '10%',
  proPlatformFee: '5%',
  minimumAge: 16,
};
